<!-- added the same component as we use in Nuxt to avoid different UI until moving these pages to Nuxt -->
<template>
  <div
    class="tooltip relative inline-block"
    :class="[isPositionBottom ? 'bottom' : 'top', { disabled: isDisabled }]"
    @mouseenter="$emit('onMouseenter')"
  >
    <slot name="trigger">
      <i class="fa-solid fa-circle-info text-[#b2b2b2]" />
    </slot>
    <div
      class="triangle border-t-8"
      :class="isDark ? 'border-t-b30' : 'border-t-white'"
    />
    <div class="tooltip-text-wrapper absolute hidden">
      <div
        class="tooltip-text px-4 py-2 text-sm"
        :class="[
          tooltipTextClass,
          isDark ? 'bg-b30' : 'bg-white',
          { 'whitespace-nowrap': isNowrap },
        ]"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
    isNowrap: {
      type: Boolean,
      default: false,
    },
    isPositionBottom: {
      type: Boolean,
      default: false,
    },
    tooltipTextClass: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.tooltip.top .tooltip-text-wrapper {
  bottom: 100%;
  padding-bottom: 16px;
}
.tooltip.bottom .tooltip-text-wrapper {
  top: 100%;
  padding-top: 10px;
}

.tooltip.top .triangle {
  bottom: calc(100% + 8px);
}
.tooltip.bottom .triangle {
  top: calc(100% + 2px);
  transform: translateX(-50%) rotate(-180deg);
}

.tooltip-text-wrapper {
  left: -40px;
  z-index: 1;
  transform: translateX(20px);
  margin-left: 50%;
}

.tooltip-text {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}

.tooltip:hover .tooltip-text-wrapper {
  display: block;
}
.tooltip-text-wrapper:hover {
  display: block;
}
.tooltip.disabled:hover .tooltip-text-wrapper {
  display: none;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  position: absolute;
  left: 0;
  -webkit-filter: drop-shadow(1px 3px 2px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(1px 3px 2px rgba(0, 0, 0, 0.2));
  z-index: 9;
  transform: translateX(-50%);
  margin-left: 50%;
  display: none;
}

.tooltip:hover .triangle {
  display: block;
}
.tooltip.disabled:hover .triangle {
  display: none;
}

@screen sm {
  .tooltip:hover .tooltip-text-wrapper {
    right: auto;
    left: auto;
    transform: translateX(-50%);
  }
}
</style>
